import { useState, useEffect, type ReactNode } from 'react';
import { Monitor } from 'lucide-react';

const MIN_WIDTH = 1024;

export function DesktopOnlyGate({ children }: { children: ReactNode }) {
  const [isTooSmall, setIsTooSmall] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < MIN_WIDTH,
  );

  useEffect(() => {
    const check = () => setIsTooSmall(window.innerWidth < MIN_WIDTH);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!isTooSmall) return <>{children}</>;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
      <div className="mx-auto max-w-sm space-y-6">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-100">
          <Monitor className="h-8 w-8 text-gray-500" />
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-gray-900">
            Desktop experience only
          </h1>
          <p className="text-sm leading-relaxed text-gray-500">
            Synter is built for desktop browsers. Please open this page on a
            device with a screen width of at least 1024 px.
          </p>
        </div>

        <div className="pt-2">
          <a
            href="https://synter.ai"
            className="text-sm font-medium text-gray-900 underline underline-offset-4 hover:text-gray-700"
          >
            Learn more about Synter
          </a>
        </div>
      </div>
    </div>
  );
}
